export default __webpack_public_path__ + "static/media/mailgateway.4977797e.svg";